var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.5C1 5.10663 4.66513 1.5 9.24268 1.5C13.8202 1.5 17.4854 5.10664 17.4854 9.5C17.4854 13.8934 13.8202 17.5 9.24268 17.5C4.66512 17.5 1 13.8934 1 9.5Z",
    fill: "#FFF5D3",
    stroke: "#FF9600",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24304 7.25C10.5192 7.25 11.5537 8.25736 11.5537 9.5C11.5537 10.7426 10.5192 11.75 9.24304 11.75C7.96689 11.75 6.93237 10.7426 6.93237 9.5C6.93237 8.25736 7.9669 7.25 9.24304 7.25Z",
    fill: "#FF9600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53717 7.3557C5.10185 6.92449 5.10402 6.23245 5.54203 5.80383C5.98692 5.36849 6.71124 5.37064 7.15339 5.80862L9.18262 7.81868C9.61794 8.24989 9.61577 8.94193 9.17776 9.37055C8.73287 9.80589 8.00855 9.80374 7.5664 9.36576L5.53717 7.3557Z",
    fill: "#FF9600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4497e5f13e0075d7ab06feb860425f99.svg";
export { ForwardRef as ReactComponent };